import React, { Component } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { Card } from "react-bootstrap";
import NavigateNext from "@material-ui/icons/NavigateNext";
import BreadCumb from "../Department/BreadCumb";
import AboutDescription from "./AboutDescription";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

const list = [
  {
    title: "About",
    link: "/aboutus/about",
  },
  {
    title: "History",
    link: "/aboutus/history",
  },
  {
    title: "Vision & Mission",
    link: "/aboutus/vision",
  },
  {
    title: "Aims & Objectives",
    link: "/aboutus/icv",
  },
];

class PanduAbout extends Component {
  state = {
    link: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;

    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    return (
      <div>
        <AboutDescription type={this.state.link} />
      </div>
    );
  }
}

export default PanduAbout;
